// import Layout from '@/components/layout/Layout.vue'
import CreateForm from '@/components/title-group/create/Create.vue'
import TitleForm from '@/components/title-group/title/Title.vue'
import { getTitleGroups,deleteTitleGroup } from '@/api/titleGroup'
import { deleteTitle } from '@/api/title'

import { getCorporations } from '@/api/open'
import moment from 'moment'

export default {
    name: 'title_group',
    components: {
        CreateForm,
        TitleForm,
        // Layout,
    },
    data() {
        return {
            data: [],
            loading: false,
            corporations: [],
            medias: [],
            selectedRowKeys: [],
            rowSelection: {
                selectedRowKeys: [],
                onChange: this.onSelectChange,
              },
            model: {},
            queryParam: { 'date': [moment().format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')] },
            showForm: false,
            titleForm: false,
            selectedTitleCount: 0,
            fullData: [],
            currentData: [],
            key: 0,
            tableGrid: this.setTable(),
            // 初始化 checkboxConfig
            checkboxConfig: {
                reserveSelection: []  // 初始化 reserveSelection 为空数组
            },
            paginationParams: {},  // 存储每个 tab 的分页参数
            selectedKeysParams: {},  // 存储每个 tab 的行选中参数
            searchValues: {},  // 存储每个 tab 的搜索值
            shortcutsR: [
                {
                  text: '今天',
                  onClick: () => {
                    this.queryParam.date = [moment().format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')]
                  },
                },
                {
                  text: '昨天',
                  onClick: () => {
                    const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
                    this.queryParam.date = [yesterday, yesterday]
                  },
                },
                {
                    text: '最近3天',
                    onClick: () => {
                      this.queryParam.date = [moment().subtract(3, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
                    },
                },
                {
                    text: '最近5天',
                    onClick: () => {
                      this.queryParam.date = [moment().subtract(5, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
                    },
                  },
                {
                  text: '最近7天',
                  onClick: () => {
                    this.queryParam.date = [moment().subtract(7, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
                  },
                },
                {
                  text: '最近14天',
                  onClick: () => {
                    this.queryParam.date = [moment().subtract(14, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
                  },
                },
                {
                  text: '最近1个月',
                  onClick: () => {
                    this.queryParam.date = [moment().subtract(1, 'months').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
                  },
                },
              ],
          
        }
    },
    mounted() {
        // 确保 checkboxConfig 正确初始化
        this.tableGrid.checkboxConfig = this.tableGrid.checkboxConfig || { reserveSelection: [] };
        getCorporations().then(res => { this.corporations = res.data.list || {} })
        this.getData()
    },
    methods: {
        setTable() {
            let table = this.$helper.tableGrid('title_group')
            table.border = 'inner'
            table.radioConfig = { checkField: 'id' }
            table.columns = this.setColumns()
            table.checkboxConfig = { reserve: true, checkField: 'selected', reserveSelection: [] };  // 确保 reserve 属性存在
            return table
        },
        setColumns() {
            return [
                { type: 'checkbox', width: 60, fixed: 'left' },
                { minWidth: 400, field: 'name', title: '名称', showOverflow: true, slots: { default: 'name' } },
                { minWidth: 80, field: 'stat_cost', title: '消耗', sortable: true },
                { minWidth: 90, field: 'convert_cnt', title: '转化数', sortable: true },
                { minWidth: 130, field: 'conversion_cost', title: '平均转化成本', sortable: true },
                { minWidth: 90, field: 'show_cnt', title: '展示数', sortable: true },
                { minWidth: 160, field: 'cpm_platform', title: '千次展现费用', sortable: true },
                { minWidth: 90, field: 'click_cnt', title: '点击数', sortable: true },
                { minWidth: 90, field: 'ctr', title: '点击率', sortable: true },
                { minWidth: 100, field: 'cpc_platform', title: '平均点击', sortable: true },
                { minWidth: 90, field: 'conversion_rate', title: '转化率', sortable: true },
                { field: 'action', title: '操作', width: 100, fixed: 'right', slots: { default: 'action' } }
            ]
        },
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys
            this.selectedTitleCount = selectedRowKeys.length
            this.rowSelection.selectedRowKeys = selectedRowKeys
        },
        create(record) {
            this.model = record.id ? Object.assign({}, record) : {}
            this.showForm = true
        },
        createTitle(record) {
            this.model = record ? Object.assign({}, record) : {}
            this.titleForm = true
        },
        getData() {
            this.tableGrid.loading = true
            const json = Object.assign({}, this.queryParam, {
                page: this.tableGrid.pagerConfig.currentPage,
                page_size: this.tableGrid.pagerConfig.pageSize
            })
            if (json.date && json.date.length > 0) {
                json.started_at = json.date[0]
                json.finished_at = json.date[1]
                delete json.date
            }

            getTitleGroups(json).then(res => {
                this.tableGrid.pagerConfig.total = res.data.list[0]?.titles_count || 0
                this.tableGrid.pagerConfig.currentPage = res.data.list[0]?.page || 1
                this.tableGrid.pagerConfig.pageSize = res.data.list[0]?.page_size || 20

                if (!this.tableGrid.pagerConfig.total) {
                    this.tableGrid.pagerConfig.total = res.data.list[0]?.titles_count || 0
                }

                if (this.currentData.length < 1) {
                    this.currentData = res.data.list[0]?.titles_list || []
                }
                this.tableGrid.loading = false
                this.tableGrid.data = res.data.list

                // 如果 this.key 还未初始化，设置为数据列表的第一个项的 ID
                if (res.data.list.length > 0) {
                    this.key = res.data.list[0].id;
                }
                this.callback(this.key)
            }).catch(() => {
                this.tableGrid.loading = false
            })
        },
        refresh() {
            this.getData()
        },
        search() {
            this.tableGrid.pagerConfig.currentPage = 1
            this.getData()
        },
        searchTitle() {
            const keyword = this.queryParam.title_name;
            if (keyword) {
                const start = (this.tableGrid.pagerConfig.currentPage - 1) * this.tableGrid.pagerConfig.pageSize;
                const end = this.tableGrid.pagerConfig.currentPage * this.tableGrid.pagerConfig.pageSize;
                const currentSearchData = this.fullData.filter(item =>
                    item.name.toLowerCase().includes(keyword)
                );
                this.currentData = currentSearchData.slice(start, end);
                this.searchValues[this.key] = {
                    currentSearchValue: keyword,
                };
                this.tableGrid.pagerConfig.total = currentSearchData.length
            } else {
                this.currentData = [...this.fullData];
                this.tableGrid.pagerConfig.total = this.currentData.length
            }
        },
        resetSearch() {
            // this.queryParam = {}
            this.queryParam = { 'date': [moment().format('YYYY-MM-DD'),moment().format('YYYY-MM-DD')] }
            this.tableGrid.pagerConfig.total = 0
            this.getData()
        },
        resetTitleSearch() {
            this.queryParam.title_name = ''
            this.searchValues[this.key] = {
                currentSearchValue: this.queryParam.title_name,
            };
            const start = (this.tableGrid.pagerConfig.currentPage - 1) * this.tableGrid.pagerConfig.pageSize;
            const end = this.tableGrid.pagerConfig.currentPage * this.tableGrid.pagerConfig.pageSize;
            this.currentData = this.fullData.filter(item =>
                item.name.toLowerCase().includes(this.queryParam.title_name)
            ).slice(start, end);
            this.tableGrid.pagerConfig.total = this.fullData.length
            // this.getData()
        },
        handlePageChange(pager) {
            this.tableGrid.pagerConfig.currentPage = pager.currentPage
            this.tableGrid.pagerConfig.pageSize = pager.pageSize

            // 保存当前 tab 的分页参数
            this.paginationParams[this.key] = {
                currentPage: pager.currentPage,
                pageSize: pager.pageSize
            };
            // this.getData()
            // 从原始数据中进行分页，更新显示数据
            const start = (pager.currentPage - 1) * pager.pageSize;
            const end = pager.currentPage * pager.pageSize;
            // 假设你已经将所有数据保存在 this.fullData 中
            this.currentData = this.fullData.filter(item =>
                item.name.toLowerCase().includes(this.queryParam.title_name)
            ).slice(start, end);
            // 保留选中的行
            this.preserveSelection();
        },
        accessTo(route) {
            return this.$helper.accessTo('TitleGroupController', route)
        },
        accessToTitle(route) {
            return this.$helper.accessTo('TitleController', route)
        },
        destroy(record) {
            const del = ids => {
                deleteTitleGroup(ids).then(res => {
                    this.$message.destroy()
                    if (res && res.code === 0) {
                        this.$message.success('删除成功')
                        this.refresh()
                    }
                })
            }
            if (!record) {
                return this.$confirm({
                    title: '操作提示',
                    centered: true,
                    content: () => <div style="color:red;">确定要删除选中的 {this.selectedRowKeys.length} 条数据吗?</div>,
                    onOk: () => {
                        del(this.selectedRowKeys)
                    }
                })
            }
            del([record.id])
        },
        destroyTitle(record) {
            const del = (ids,record) => {
                deleteTitle({ids:ids, record:record}).then(res => {
                    this.$message.destroy()
                    if (res && res.code === 0) {
                        this.$message.success('删除成功')
                        this.refresh()
                    }
                })
            }
            if (!record) {
                return this.$confirm({
                    title: '操作提示',
                    centered: true,
                    content: () => <div style="color:red;">确定要删除选中的 {this.selectedRowKeys.length} 条数据吗?</div>,
                    onOk: () => {
                        del(this.selectedRowKeys, record)
                    }
                })
            }
            del(null, record)
        },
        callback(key) {
            // 清空选中的行
            // this.selectedRowKeys = [];
            // this.rowSelection.selectedRowKeys = [];
            // 查找当前选中的分类
            this.key = key;

            // 如果当前 tab 没有分页参数，初始化它
            if (!this.paginationParams[key]) {
                this.paginationParams[key] = {
                    currentPage: 1,
                    pageSize: 20
                };
            }

            if (!this.searchValues[key]) {
                this.searchValues[key] = {
                    currentSearchValue: '',
                };
            }

            const { currentSearchValue } = this.searchValues[key];
            this.queryParam.title_name = currentSearchValue;
            
            // 从已保存的参数中获取 currentPage 和 pageSize
            const { currentPage, pageSize } = this.paginationParams[key];
            this.tableGrid.pagerConfig.currentPage = currentPage;
            this.tableGrid.pagerConfig.pageSize = pageSize;

            // 更新数据
            const selectedCategory = this.tableGrid.data.find(category => category.id === key);
            // 更新分页器的总页数
            if (selectedCategory) {
                this.tableGrid.pagerConfig.total = selectedCategory.titles_count;
                this.fullData = selectedCategory.titles_list;
                // 根据当前分页参数更新显示数据
                const start = (currentPage - 1) * pageSize;
                const end = currentPage * pageSize;
                // 假设你已经将所有数据保存在 this.fullData 中
                // this.currentData = this.fullData.slice(start, end);
                if (this.queryParam.title_name) {
                    this.currentData = this.fullData.filter(item =>
                        item.name.toLowerCase().includes(this.queryParam.title_name)
                    );
                    this.tableGrid.pagerConfig.total = this.currentData.length
                } else {
                    this.currentData = this.fullData.slice(start, end);
                }
                // 保留选中的行
                this.preserveSelection();
            }
        },
        preserveSelection() {
            this.$nextTick(() => {
                if (this.tableGrid.checkboxConfig && this.tableGrid.checkboxConfig.reserveSelection) {
                    const reservedIds = this.tableGrid.checkboxConfig.reserveSelection;
                    this.selectedRowKeys = [...new Set([...this.selectedRowKeys, ...reservedIds])];
                    this.selectedTitleCount = this.selectedRowKeys.length;
                    this.rowSelection.selectedRowKeys = this.selectedRowKeys;
                }
            });
        },
        copyTitle(text) {
            event.stopPropagation(); // 阻止事件冒泡
            this.$helper.clipboard(text)
            this.$message.success('复制成功')
        },
        batchCopyTitle() {
            if (this.selectedRowKeys.length === 0) {
                this.$message.warning('请选中需要复制的内容');
                return;
            }
            const selectedTitles = this.selectedRowKeys
            .map(key => {
                const category = this.tableGrid.data.find(category => category.titles_list.some(item => item.id === key));
                return category ? category.titles_list.find(item => item.id === key).name : '';
            })
            .filter(name => name)
            .join('\n')
            this.$helper.clipboard(selectedTitles);
            this.$message.success('复制成功')
        },
        handleRowChange(result) {
            // 获取当前选中的行记录
            const newSelectedKeys = result.records.map(item => item.id);
            
            // 保存当前选中记录到 selectedKeysParams
            this.selectedKeysParams[this.key+'_'+this.tableGrid.pagerConfig.currentPage] = newSelectedKeys;

            // 将 selectedKeysParams 中的所有值合并为一个一维数组
            this.selectedRowKeys = Object.values(this.selectedKeysParams).flat();
    
            // 使用 Set 来确保 selectedRowKeys 中不包含重复的值
            this.selectedRowKeys = [...new Set(this.selectedRowKeys)];
            this.selectedTitleCount = this.selectedRowKeys.length;

            // 更新 rowSelection 的 selectedRowKeys
            this.rowSelection.selectedRowKeys = this.selectedRowKeys;
            
            // 手动保存当前的选中记录
            this.$set(this.tableGrid, 'checkboxConfig', {
                ...this.tableGrid.checkboxConfig,
                reserveSelection: this.selectedRowKeys,
            });
        },
        handleRowClick({ row }) {
            // 获取当前 tab 的 vxe-grid 实例
            const grid = this.$refs['grid_' + this.key][0];
        
            // 获取当前行的 ID
            const rowId = row.id;
        
            // 检查当前行是否已经被选中
            if (!this.selectedRowKeys.includes(rowId)) {
                // 如果未选中，将其添加到选中列表
                grid.setCheckboxRow(row, true);
            } else {
                // 如果已选中，则从选中列表中移除
                grid.setCheckboxRow(row, false);
            }
        
            // 更新选中的行记录到 selectedKeysParams
            const newSelectedKeys = grid.getCheckboxRecords().map(item => item.id);
            this.selectedKeysParams[this.key + '_' + this.tableGrid.pagerConfig.currentPage] = newSelectedKeys;
        
            // 合并所有的选中项，使用 Set 去重
            this.selectedRowKeys = Object.values(this.selectedKeysParams).flat();
            this.selectedRowKeys = [...new Set(this.selectedRowKeys)];
        
            // 更新 rowSelection 的 selectedRowKeys
            this.rowSelection.selectedRowKeys = this.selectedRowKeys;
        
            // 更新选中的标题数量
            this.selectedTitleCount = this.selectedRowKeys.length;
        
            // 手动保存当前的选中记录
            this.$set(this.tableGrid, 'checkboxConfig', {
                ...this.tableGrid.checkboxConfig,
                reserveSelection: this.selectedRowKeys,
            });
        },
        onEdit(targetKey, action) {
            console.log(targetKey, action)
            if (action === 'remove') {
                this.$confirm({
                    title: '操作提示',
                    centered: true,
                    content: () => <div style="color:red;">确定要删除该标题组吗?</div>,
                    onOk: () => {
                        this.destroy({ id: targetKey });
                    },
                });
            }
        },
        handleSortChange(data) {
            this.queryParam.sort_field = data.order ? data.field : null
            this.queryParam.sort_type = data.order
            if (this.queryParam.sort_field && this.queryParam.sort_type) {
                this.fullData.sort((a, b) => {
                    let fieldA = a[this.queryParam.sort_field];
                    let fieldB = b[this.queryParam.sort_field];
            
                    // 如果字段值是字符串类型，则进行本地比较
                    if (typeof fieldA === 'string' && typeof fieldB === 'string') {
                        fieldA = fieldA.toLowerCase();
                        fieldB = fieldB.toLowerCase();
                    }
            
                    // 将字段值转换为数字（如果可能）
                    fieldA = parseFloat(fieldA) || fieldA;
                    fieldB = parseFloat(fieldB) || fieldB;
            
                    // 根据排序类型进行升序或降序排序
                    if (this.queryParam.sort_type === 'asc') {
                        return fieldA > fieldB ? 1 : -1;
                    } else if (this.queryParam.sort_type === 'desc') {
                        return fieldA < fieldB ? 1 : -1;
                    }
            
                    return 0;
                });
            }
            // 重新设置分页后的数据
            this.tableGrid.pagerConfig.currentPage = 1;
            const start = (this.tableGrid.pagerConfig.currentPage - 1) * this.tableGrid.pagerConfig.pageSize;
            const end = this.tableGrid.pagerConfig.currentPage * this.tableGrid.pagerConfig.pageSize;
            this.currentData = this.fullData.filter(item =>
                item.name.toLowerCase().includes(this.queryParam.title_name)
            ).slice(start, end);
            // this.currentData = this.fullData.slice(start, end);
        },
    }
}
